var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationCircleRedIcon = function SvgExclamationCircleRedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C70032",
    fillRule: "evenodd",
    d: "M7.5 9.5h1v-5h-1zm0 2h1v-1h-1zM8 .5C3.864.5.5 3.864.5 8s3.364 7.5 7.5 7.5 7.5-3.364 7.5-7.5S12.136.5 8 .5",
    clipRule: "evenodd"
  })));
};
export default SvgExclamationCircleRedIcon;